import { render, staticRenderFns } from "./InputArrayItem.global.vue?vue&type=template&id=5f673e0a&lang=pug&"
import script from "./InputArrayItem.global.vue?vue&type=script&lang=ts&"
export * from "./InputArrayItem.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports